import * as React from 'react';
import Filtering from '../../../workflow/controls/ResourcesControl/FilterManager/Filtering';
import { IData } from './IModels';
import { makeid } from '../../utils/randomHelper';
import { Checkboxs } from '../GridHelper/GridRowCheckboxs';

interface IShowResourcesGridProps {
	filterId?: string,
	gridId: string,
	ajaxSource: string,
	gridColumns: any,
	manageFiltersPermission: boolean,

	filterModel: string,

	idIndex: number,
	hdKindIndex: number | (keyof IData),

	checkboxClassName: string,

	onRowCallback?: (nRow: HTMLElement, aData, iDisplayIndex: number, data) => void,
}

export default function ShowResourcesGrid(props: IShowResourcesGridProps) {
	const [selected, setSelected] = React.useState<{ [key: string]: boolean }>({});
	const gridRef = React.useRef<HTMLDivElement>();
	const _filtering = React.useRef<Filtering>();
	const [pageCompletedGrid, setPageCompletedGrid] = React.useState<{ oGrid: any }>(null);
	const [handleRowSelect, setHandleRowSelect] = React.useState<{ nRow?: HTMLElement, selected?: boolean }>({});
	const forceHandleRowSelect = React.useCallback((nRow: HTMLElement, selected: boolean) => setHandleRowSelect({ nRow: nRow, selected: selected }), []);
	const forceUpdate = React.useCallback((gr) => setPageCompletedGrid({ oGrid: gr }), []);

	React.useEffect(() => {
		if (pageCompletedGrid) {

		}
	}, [pageCompletedGrid]);

	React.useEffect(() => {
		if (handleRowSelect.nRow) {
			let key = handleRowSelect.nRow.dataset.key;
			let copy = { ...selected };
			copy[key] = handleRowSelect.selected;
			setSelected(copy);
		};
	}, [handleRowSelect]);


	React.useEffect(() => {
		try {
			let gridSetup = new (window as any).GridSetup()
				.forId('#' + props.gridId)
				.setColumns(props.gridColumns)
				.withColumnSelector()
				.withFilterManager(props.filterModel, _filtering.current.getManager())
				.setAjaxSource(props.ajaxSource);

			if (props.filterId)
				gridSetup = gridSetup.setFilterId(props.filterId);

			const grid = gridSetup
				.onRowCallback(function (nRow, aData, iDisplayIndex) {

					function renderCheckbox(columnIndices, row: HTMLElement, data) {
						if (columnIndices) {
							let key = data[props.idIndex].toString();
							if (typeof props.hdKindIndex === 'number') {
								key += "_" + data[props.hdKindIndex];
							}
							let td = (window as any).$('td:eq(' + columnIndices.visibleIndex + ')', row);
							row.dataset.key = key;
							td.html(`<div id="${makeid(7)}" class="${props.checkboxClassName}" data-key="${key}"></div>`);
						}
					}
					let data = grid.fnGetModelData(aData);

					let selectedIndices = grid.fnGetColumnIndicesByName('Selected');
					renderCheckbox(selectedIndices, nRow, aData);

					if (props.onRowCallback)
						props.onRowCallback(nRow, aData, iDisplayIndex, data)
				})
				.onRowSelect(function (e, oGrid, nRow) {
					let selected = (window as any).switchRow(nRow);
					forceHandleRowSelect(nRow, selected);
				})
				.onPageComplete(function (gr) {
					forceUpdate(gr);
				})
				.Create();

			return () => {
				try {
					grid.fnDestroy();
				}
				catch (e) {
					console.error(e);
				}
			}
		}
		catch (e) {
			console.error(e);
		}

	}, []);

	return <>
		<Filtering
			ref={_filtering}
			manageFiltersPermission={props.manageFiltersPermission}
		/>
		<Checkboxs selected={selected} setSelected={setSelected} gridRef={gridRef} />
		<div id="xgrid" ref={gridRef}>
			<table className="display resourceGrid grid-scrollable grid-scrollable-resources" style={{ height: "calc(100vh - 450px)" }} id={props.gridId}>
				<tfoot><tr></tr></tfoot>
			</table>
		</div>
	</>
}